<template>
  <NodeFrontendPage v-if="node" v-bind="node" />
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'drupal-route',
  path: '/:slug(.*)*',
})

const { entity: node } = await useDrupalRouteQuery('slug')

await renderPageDependencies()
</script>
